import { useEffect, useState } from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { Typography } from "./components/kit";
import Loader from "./components/common/Loader";
import * as Sentry from "@sentry/react";

function setWithExpiry(key: string, value: string, ttl: number) {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key: string) {
  const itemString = window.localStorage.getItem(key);
  if (!itemString) return null;

  const item = JSON.parse(itemString);
  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

function reloadPage() {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
  setTimeout(() => {
    window.location.reload();
  }, 2000);
}

export default function ErrorFallback() {
  const error: any = useRouteError();
  const navigate = useNavigate();
  console.log(
    "🚀 ~ file: ErrorFallBack.tsx:42 ~ ErrorFallback ~ error:",
    error,
  );
  const [errorName, setErrorName] = useState("");

  useEffect(() => {
    const dynamicFailedMessage = "Failed to fetch dynamically imported module";

    if (error.status === 404) {
      navigate("/404");
    }
    if (
      error &&
      error?.message &&
      error.message.includes(dynamicFailedMessage)
    ) {
      if (!getWithExpiry("chunk_failed")) {
        setErrorName("chunk_failed");
        setWithExpiry("chunk_failed", "true", 10000);
        reloadPage();
      }
    }
  }, [error]);

  useEffect(() => {
    if (error) {
      Sentry.captureException(error, {
        tags: { boundary: "router" },
        extra: { route: window.location.pathname },
      });
    }
  }, [error]);

  // Uncaught ReferenceError: path is not defined
  return (
    <div className="w-screen h-screen flex items-center dark:!bg-shades-dark justify-center flex-col">
      {errorName === "chunk_failed" ? (
        <Loader />
      ) : (
        <Typography variant="Title1-Bold">Something went wrong.</Typography>
      )}
    </div>
  );
}
